import { can } from './permissions.generated';
import type { ControllerSummary, VenueRole } from './types';

export interface RenameDeviceResult {
  deviceId: string;
  displayName: string;
  nudged: boolean;
}

/** Match renameDevice's platform authorization gate. */
export function canRenameDevice(role: VenueRole): boolean {
  return can(role, 'room.manage');
}

/** Apply only the identity returned by the platform; Firestore remains the durable source of truth. */
export function controllersAfterRename(
  controllers: ControllerSummary[],
  result: RenameDeviceResult,
): ControllerSummary[] {
  return controllers.map((controller) => controller.deviceId === result.deviceId
    ? { ...controller, displayName: result.displayName }
    : controller);
}
